/* src/app/features/porte-beneficiario/listagem/porte-beneficiario-listagem.component.scss */
/*# sourceMappingURL=porte-beneficiario-listagem.component.css.map */
